import type { FaireProductEntity } from "../../entity_types/product";

export const p_98sd57tnmh: FaireProductEntity = {
  token: "p_98sd57tnmh",
  type: "product",
  name: "Kids Baseball Glitter patch Oversized Pullover",
  brandToken: "b_czn89sb32s",
  brandName: "Oddi",
  imageUrl:
    "https://cdn.faire.com/fastly/12560bb6595d1a19c2ab0f6471dc0724d61b85fc72d4c2977927723f002413b7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/82429d1a9058cad2796f99375273b40ce3ce09dbf45e36d3536635778d21ae06.jpeg",
    "https://cdn.faire.com/fastly/e861719948ac67d5965aafae00abecfde2e883522eeb92143ea024e2b139c826.jpeg",
    "https://cdn.faire.com/fastly/b80097caa9f248a5dab7bf8407aa0bd673fd6e1bec82c1c1b07ba9f4f658e614.jpeg",
  ],
  priceDollars: 143.2,
  description:
    "Baseball glitter patch crew neck oversized pullover featuring dropped shoulders, short sleeve and raw seam.\nMatching with MOMMY.\nStyles. IT17032&IT17032P\nMade in country: imported.",
  tags: [],
  msrpDollars: 286.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:50.817Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
